import { Button } from '@/components/ui/Button';
import { useAuth } from '@/lib/auth';

export function ImpersonationBanner() {
  const { impersonator, me, endImpersonation } = useAuth();
  if (!impersonator || !me) return null;
  return (
    <div className="flex items-center gap-3 border-b border-amber-300 bg-amber-100 px-6 py-2.5 text-sm text-amber-900">
      <span className="font-semibold">Impersonating {me.user.email}</span>
      <span className="text-amber-700">
        as {impersonator}. Every action is recorded under your name.
      </span>
      <Button size="sm" variant="primary" className="ml-auto" onClick={() => void endImpersonation()}>
        End impersonation
      </Button>
    </div>
  );
}
